import React from 'react';
import AdminLayout from '../../../components/Layout/AdminLayout';
import Refunds from './Refunds';
import { restrictUrls } from '../../../helpers/adminPrivileges';
import messages from '../../../locale/messages';

function action({ store, intl }) {
    const title = intl.formatMessage(messages.manageRefunds);

    //From Redux Store
    let isAdminAuthenticated = store.getState().runtime.isAdminAuthenticated;
    let adminPrivileges = store.getState().account.privileges && store.getState().account.privileges.privileges;
    let privileges = store.getState().commonSettings && store.getState().commonSettings.privileges;

    if (!isAdminAuthenticated) {
        return { redirect: '/siteadmin/login' };
    }
    // Admin restriction (privilege 26 — Manage refunds). Viewing only: money
    // authorization is enforced again by the refund engine per mutation.
    if (!restrictUrls('/siteadmin/refunds', adminPrivileges, privileges)) {
        return { redirect: '/siteadmin' };
    }

    return {
        title,
        component: (
            <AdminLayout><Refunds title={title} /></AdminLayout>
        ),
    };
}

export default action;
